export default __webpack_public_path__ + "static/media/twitter.b81267dc.svg";